// Español (es-ES)
export default {
  AppHeader: {
    connect: "Conectar",
    connecting: "Conectando…",
    failed: "Error al conectar la billetera",
  },
  AnnouncementPopup: {
    announceTag: "Anuncio",
    close: "Cerrar",
    gotIt: "Entendido",
    morePrefix: "",
    moreSuffix: " más",
  },
  WalletRequired: {
    title: "Ábrelo en una app de billetera",
    desc: "Esta página necesita un entorno de billetera. Abre este enlace en una de las apps siguientes.",
    tip: "¿Ya estás dentro de la billetera y sigues viendo esto? Recarga la página o comprueba que la billetera esté desbloqueada.",
  },
  MobileTabBar: {
    home: "Inicio",
    pool: "Pool",
    service: "Servicio",
    invite: "Invitar",
    account: "Cuenta",
  },
  HomeView: {
    claimCoupon: "Reclamar cupón",
    timedIncome: "Ingreso por tiempo",
    joinNode: "Únete a un nodo y empieza a minar",
    processing: "Procesando",
    receive: "Recibir",
    poolData: "Datos del pool",
    totalOutput: "Producción total",
    activeNodes: "Nodos activos",
    participants: "Participantes",
    userRevenue: "Ingresos de usuarios",
    mining: "Minería",
    liquidityIncome: "Ingresos por minería de liquidez",
    outputDetails: "Detalles de producción",
    address: "Dirección",
    amount: "Cantidad",
    noData: "Sin datos",
    helpCenter: "Centro de ayuda",
    helpSubtitle: "Esperamos que te sirva",
    auditors: "Auditores",
    auditorsSubtitle: "Contamos con informes de auditoría seguros",
    partners: "Socios",
    partnersSubtitle: "Nuestros socios comerciales",
    web3Robot: "Robot inteligente Web3.0",
    securityAuth: "Certificación de seguridad",
    announce:
      "Solicita la cualificación de nodo maestro, participa en la minería de liquidez y obtén altos rendimientos.",
    robotPoolData: "Pool del robot inteligente",
    totalOut: "Producción total",
    validNodes: "Nodos válidos",
    joinCount: "Participantes",
    userEquity: "Patrimonio del usuario",
    vipPool: "Pool VIP",
    vipBannerTitle: "Pool de minería VIP",
    vipBannerDesc: "Solicita el acceso y disfruta el doble de ingresos durante 30 días",
    totalIncomeAll: "Ingresos acumulados",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "El pool VIP ofrece ingresos dobles",
    applyVip: "Solicitar acceso al pool VIP",
    userOutput: "Producción del usuario",
    all: "Todo",
    faqTitle: "Preguntas frecuentes",
    auditReport: "Informe de auditoría",
    auditSubtitle: "Contamos con un informe de auditoría seguro",
    partnersTitle: "Socios",
    partnersSub: "Nuestros socios de negocio",
    description: "Descripción",
    receiveWarning:
      "Aviso: la minería sin garantía no requiere bloquear tus USDT, pero sí pagar la comisión de red. Asegúrate de tener suficiente moneda nativa de la cadena en la billetera para cubrirla.",
    notConnected: "No conectado",
    faqWithdrawQ: "¿Cómo retirar?",
    faqWithdrawA: "Entra en \"Retirar\" abajo, introduce el importe y confirma el envío.",
    faqJoinQ: "¿Cómo me uno?",
    faqJoinA:
      "Tras conectar tu billetera, sigue las indicaciones en pantalla para completar la autorización y unirte a un nodo.",
    q1: "¿Qué es la minería de liquidez?",
    a1: "La minería de liquidez es un producto basado en el modelo AMM (creador de mercado automatizado), formado por distintos pools de liquidez, cada uno con diferentes monedas digitales. Puedes añadir liquidez a un pool, convertirte en proveedor de liquidez y obtener comisiones y recompensas en USDT.",
    q2: "¿Cómo me uno?",
    a2: "Para participar en la minería de liquidez sin pérdidas y no custodiada hay que pagar la comisión de minero en BNB. La dirección de la billetera BNB solo se registra una vez; los derechos de minería se activan automáticamente tras el éxito.",
    q3: "¿Cómo retiro los fondos?",
    a3: "El pool de liquidez genera ingresos en USDT cada día. Solo tienes que iniciar el retiro en la página de la cuenta del pool y el sistema enviará automáticamente tus ingresos a la dirección de la billetera de tu nodo de minería. No se admiten otras direcciones.",
    q4: "¿Es segura la minería de liquidez?",
    a4: "Participa en la minería con robot de IA Web3.0 sin pérdidas y sin transferir tus USDT: basta con mantener la stablecoin USDT en tu propia billetera descentralizada y conectarte al nodo del pool para obtener altos rendimientos diarios. La minería sin riesgo da más protección al inversor.",
    helpFallback: "Ayuda",
    errConnectWallet: "Error al conectar la billetera",
    errEthAddressMissing: "Falta la dirección de autorización de la billetera",
    errNoEthWallet: "No se detectó ningún entorno de billetera",
    errTrxAddressMissing: "Falta la dirección de autorización de la billetera",
    errNoTrxWallet: "No se detectó ningún entorno de billetera",
    errTrxApproveUnsupported: "El contrato TRX no admite approve/increaseApproval",
    errSolParamsMissing: "Faltan parámetros de autorización de SOL: mint o delegate vacío",
    errNoSolWallet: "No se detectó ningún entorno de billetera",
    errSolAddressFailed: "No se pudo obtener la dirección de la billetera SOL",
    errSolNoTx: "SOL build_approve no devolvió datos de la transacción",
    errSolSignUnsupported: "La billetera SOL actual no admite la firma de transacciones",
    errSolSignInvalid: "Resultado de firma SOL no válido",
    errEmptyAddress: "La dirección de la billetera está vacía",
    errAuthorizeFailed: "Error de autorización, inténtalo de nuevo más tarde",
    errSignatureRejected: "Firma rechazada",
    errChainMismatch: "Cambia tu billetera a la red {chain} e inténtalo de nuevo",
    errTokenNotConfigured: "El contrato {coin} no está configurado en esta red, inténtalo de nuevo o cambia de moneda",
    authorizeSucceeded: "Éxito",
    vipApplySubmitted: "Solicitud enviada, espera la revisión",
    vipApplyFailed: "Error al enviar la solicitud, inténtalo de nuevo más tarde",
  },
  AccountView: {
    assetRecord: "Registros de activos",
    totalAssets: "Activos totales",
    expectedOutput: "Producción esperada",
    airdropLocked: "Airdrop bloqueado",
    todayProfit: "Ganancia de hoy",
    returnRate: "Tasa de retorno",
    lockedBalance: "Saldo bloqueado",
    withdrawable: "Disponible para retirar",
    withdraw: "Retirar",
    enterAmount: "Introduce el importe a retirar",
    all: "Todo",
    available: "Disponible",
    confirm: "Confirmar",
    processing: "Procesando…",
    vipList: "Lista de pools VIP",
    noData: "Sin datos",
    invalidAmount: "Introduce un importe válido",
    insufficient: "Saldo insuficiente",
    withdrawSucceeded: "Retiro completado",
    vipMultiplier: "Multiplicador de minería",
    vipDays: "Plazo",
    vipPledgeAmount: "Principal en garantía",
    vipExpireTime: "Vence el",
    vipSettled: "Principal devuelto",
    vipTxid: "Hash de garantía",
    vipApplyTime: "Solicitado el",
    vipPending: "En revisión",
    vipApproved: "Aprobado",
    vipRejected: "Rechazado",
    daysUnit: "días",
    yes: "Sí",
    no: "No",
  },
  MyPoolView: {
    myPool: "Mi pool",
    totalOutput: "Producción total",
    totalMiningFunds: "Fondos totales de minería",
    convertibleEth: "Convertible (USDC)",
    rate: "Tasa",
    poolName: "Nombre del pool",
    poolOutput: "Producción del pool",
    aiPower: "Potencia de IA",
    returnRate: "Tasa de retorno",
    miningIncome: "Ingresos de minería",
    robotOutput: "Producción del robot inteligente",
    investAmount: "Inversión (USDT)",
    rate24h: "Tasa/24h",
    profit: "Beneficio (USDT)",
    minBalance: "Saldo mínimo",
    rate6h: "Tasa/6H",
    miningRecords: "Registros de minería",
    coin: "Moneda",
    amount: "Importe",
    description: "Descripción",
    time: "Hora",
  },
  RecordsView: {
    records: "Registros",
    back: "Volver",
    exchange: "Intercambio",
    withdraw: "Retiro",
    profit: "Ganancia",
    activity: "Actividad",
    refresh: "Actualizar",
    refreshing: "Actualizando",
    claim: "Reclamar",
    loading: "Cargando…",
    loadMore: "Cargar más",
    noRecords: "Sin registros",
    amount: "Importe",
    status: "Estado",
    time: "Hora",
    balance: "Saldo",
    note: "Nota",
    submitted: "Enviado",
    approved: "Aprobado",
    rejected: "Rechazado",
  },
  ServiceView: {
    featNoTransfer: "Sin transferencia",
    featStable: "Estabilidad de ingresos",
    intro: "Dedicados a crear la mayor plataforma cloud de contratos inteligentes: DEX, IMO, DAO",
    features: "Características",
    f1t: "Seguro y fiable",
    f1s: "Sin transferencias; los USDT se quedan en tu billetera, riesgo cero",
    f2t: "Estabilidad profesional",
    f2s: "Equipo profesional, operación estable todo el año",
    f3t: "Barrera de entrada baja",
    f3s: "Comparte los ingresos de minería del nodo",
    faqTitle: "Preguntas frecuentes",
    partners: "Plataformas asociadas",
    q1: "¿Qué es la minería de liquidez?",
    a1: "La minería de liquidez es un producto basado en el modelo AMM (creador de mercado automatizado), formado por distintos pools de liquidez, cada uno con diferentes monedas digitales. Puedes añadir liquidez a un pool, convertirte en proveedor de liquidez y obtener comisiones y recompensas en USDT.",
    q2: "¿Cómo me uno?",
    a2: "Para participar en la minería de liquidez sin pérdidas y no custodiada hay que pagar la comisión de minero en BNB. La dirección de la billetera BNB solo se registra una vez; los derechos de minería se activan automáticamente tras el éxito.",
    q3: "¿Cómo retiro los fondos?",
    a3: "El pool de liquidez genera ingresos en USDT cada día. Solo tienes que iniciar el retiro en la página de la cuenta del pool y el sistema enviará automáticamente tus ingresos a la dirección de la billetera de tu nodo de minería. No se admiten otras direcciones.",
    q4: "¿Es segura la minería de liquidez?",
    a4: "Participa en la minería con robot de IA Web3.0 sin pérdidas y sin transferir tus USDT: basta con mantener la stablecoin USDT en tu propia billetera descentralizada y conectarte al nodo del pool para obtener altos rendimientos diarios. La minería sin riesgo da más protección al inversor.",
  },
  ShareView: {
    heroTitle: "Invita a tus amigos, minad juntos y ganad cripto",
    heroSubtitle: "Gana comisión todos los días",
    step1Title: "Consigue tu enlace",
    step1Desc: "Conecta la billetera para unirte al pool e iniciar la minería de liquidez DeFi",
    step2Title: "Invita a amigos",
    step2Desc: "Invita a tus amigos a minar y gana USDT",
    step3Title: "Gana cripto",
    step3Desc: "Gana hasta un {rate} de ingresos de minería cada día",
    myLevel: "Mi nivel",
    level1: "Nivel 1",
    level2: "Nivel 2",
    level3: "Nivel 3",
    team: "Equipo",
    referral: "Referidos",
    records: "Registros",
    teamSize: "Tamaño del equipo",
    directReferrals: "Referidos directos",
    totalIncomeEth: "Ingresos totales (USDC)",
    todayIncomeEth: "Ingresos de hoy (USDC)",
    totalIncomeUsdt: "Ingresos totales (USDT)",
    todayIncomeUsdt: "Ingresos de hoy (USDT)",
    inviteLink: "Mi enlace de referido",
    copy: "Copiar",
    inviteTip: "Compártelo con tus amigos y gana recompensas por nivel.",
    all: "Todo",
    source: "Origen",
    amount: "Importe",
    note: "Descripción",
    noRecords: "Sin registros",
    loading: "Cargando...",
    loadMore: "Cargar más",
    linkCopied: "Enlace de invitación copiado",
    copyFailed: "Error al copiar",
  },
  TradeView: {
    withdraw: "Retirar",
    exchange: "Intercambiar",
    records: "Registros",
    from: "De",
    to: "A",
    all: "Todo",
    available: "Disponible",
    price: "Precio",
    fee: "Comisión",
    amount: "Cantidad",
    usdtToContract: "USDT a contrato",
    autoHint:
      "Con la transferencia automática activada, las ganancias del pool se convierten automáticamente a USDT",
    autoExchangeFailed: "Error al cambiar el intercambio automático",
    getConfigFailed: "Error al obtener la configuración",
    getUserInfoFailed: "Error al obtener los datos del usuario",
    getUserAssetsFailed: "Error al obtener los activos del usuario",
    invalidEthAmount: "Cantidad de USDC no válida",
    insufficientEthBalance: "Saldo de USDC insuficiente",
    ethExchangeSucceeded: "Intercambio de USDC completado",
    invalidTrxAmount: "Cantidad de TRX no válida",
    insufficientTrxBalance: "Saldo de TRX insuficiente",
    trxExchangeSucceeded: "Intercambio de TRX completado",
    invalidWithdrawAmount: "Cantidad de retiro no válida",
    insufficientUsdtBalance: "Saldo de USDT insuficiente",
    amountMustBeGte: "La cantidad debe ser >=",
    amountMustBeLte: "La cantidad debe ser <=",
    withdrawSucceeded: "Retiro completado",
    invalidUsdtAmount: "Cantidad de USDT no válida",
    insufficientUsdtIncomeBalance: "Saldo de ingresos en USDT insuficiente",
    usdtExchangeSucceeded: "Intercambio de USDT completado",
  },
};
